import { Fragment, useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import RouteMap from '../../components/RouteMap';

const CompletedContainer = () => {
  const { t } = useTranslation();
  const { trackingDetails } = useContext(AppContext);
  dayjs.extend(calendar);

  return (
    <Fragment>
      <RouteMap />
      {trackingDetails?.task?.completedAt && (
        <div className="map_summary">
          <p style={{ marginBottom: 10 }}>{t('completed_summary')}</p>
          <h3
            style={{
              marginBottom: 40
            }}
          >
            {dayjs(trackingDetails?.task?.completedAt || new Date(Date.now() - 5 * 60 * 1000)).format('YYYY-MM-DD, HH:mm')}
          </h3>
        </div>
      )}
    </Fragment>
  );
};

export default CompletedContainer;
